import React, { FunctionComponent, useContext, useState } from "react";
import { ListActionButtonProps, Aside } from "sprint-common-web";

import { EditListButton } from "../../../../../../common/components/buttons/EditListButton";
import { DistributorsDataProvider } from "../../../../../../common/data/lookup-data-providers/DistributorsDataProvider";
import { EpisodeVersionDetails } from "../../../../TvSeriesDetails";
import { EpisodeVersionListContext } from "../context/EpisodeVersionListProvider";
import { EditEpisodeVersionForm, UpdateEpisodeVersionParams } from "../edit-version-form/EditEpisodeVersionForm";

export const EditEpisodeVersionButton: FunctionComponent<ListActionButtonProps> = (props: ListActionButtonProps) => {
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);
    const { updateEpisodeVersion, selectedEpisode } = useContext(EpisodeVersionListContext);

    const handleClick = (event?: React.MouseEvent<HTMLButtonElement>) => {
        event?.currentTarget.blur();

        setIsAsideOpen(true);

        if (props.onClick) {
            props.onClick();
        }
    };

    const handleEditEpisodeVersionFormSubmit = (updatedEpisodeVersionData: UpdateEpisodeVersionParams) => {
        updateEpisodeVersion(updatedEpisodeVersionData);
        setIsAsideOpen(false);
    };

    const closeEditEpisodeVersionSidebar = () => {
        setIsAsideOpen(false);
    };

    const editButtonDisabled = () => {
        const currentEpisodeVersion = selectedEpisode.versions.find(
            (version: EpisodeVersionDetails) => version.id === props.itemId
        );

        return !!currentEpisodeVersion?.mergedTargetId || props.disabled;
    };

    return (
        <DistributorsDataProvider>
            <EditListButton disabled={editButtonDisabled()} onClick={handleClick} />
            <Aside
                isOpen={isAsideOpen}
                type="form"
                headerText="Edit Episode Version"
                onDismiss={closeEditEpisodeVersionSidebar}
            >
                <EditEpisodeVersionForm
                    onCancel={closeEditEpisodeVersionSidebar}
                    onSubmit={handleEditEpisodeVersionFormSubmit}
                    selectedEpisodeVersionId={props.itemId ?? ""}
                />
            </Aside>
        </DistributorsDataProvider>
    );
};
